import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { adminMainUrl } from '../../../../../Config';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select'
import { customStyles } from '../../../../../HelperFunctions';
import TextAreaJSX from './TextAreaJSX';
import InputTextJSX from './InputTextJSX';
import InputDateJSX from './InputDateJSX';
import SelectReactJSX from './SelectReactJSX';
import { useDispatch, useSelector } from 'react-redux';
import { getFFAirImpConsigneeBranch, getFFAirImpConsigneeBranchBank, getFFAirImpOrganisationBranch, getFFAirImpShipperBranch, getFFAirImpShipperBranchBank } from '../../../../../Redux/action/FreightForwarding/Console/FFAirImpAction';
import { getRateclassList } from '../../../../../Redux/action/MasterAction';

const DirectShipmentMAWBEditAI = ({
    trans_mode,
    job_order_id,
    quotation_id,
    loadingCurrency,
    currencyOptions,
    loadingAirport,
    airportOptions,
    loadingOrganisation,
    organisationOptions,
    token,
    user_id,
    FFAirImpDirectMAWBDetail,
    b64id,
    accessedPermission,
    iataAgentOptions
}) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // ---------- Flight Segments State ----------
    const [flightSegments, setFlightSegments] = useState([]);
    const defaultSegment = {
        airport_of_departure_id: "",
        airport_of_departure_name: "",
        airport_of_destination_id: "",
        airport_of_destination_name: "",
        to: "",
        to_second: "",
        by_first_carrier: "",
        by_second_carrier: "",
        flight_no: "",
        flight_date: "",
        cto: "",
    };
    // -------------------------------------------

    useEffect(() => {
        if (token && user_id) {
            // dispatch(getChargehead(token, user_id));
            dispatch(getRateclassList(token, user_id));
        }
    }, [token, user_id]);

    const {
        // loadingChargehead,
        // chargeheadData,
        RateclassList
    } = useSelector(state => state.MasterReducer);

    let [rateclassOptions, setRateclassOptions] = useState([]);
    useEffect(() => {
        if (RateclassList) {
            let arr = [];
            RateclassList.map((v) => { arr.push({ label: v.name, value: v.id }) });
            setRateclassOptions(arr);
        } else {
            setRateclassOptions([]);
        }
    }, [RateclassList]);

    let [shipperOrganisationOptions, setShipperOrganisationOptions] = useState([]);
    let [consigneeOrganisationOptions, setConsigneeOrganisationOptions] = useState([]);

    let [shipperBranchOptions, setShipperBranchOptions] = useState([]);
    let [consigneeBranchOptions, setConsigneeBranchOptions] = useState([]);

    let [shipperBankOptions, setShipperBankOptions] = useState([]);
    let [consigneeBankOptions, setConsigneeBankOptions] = useState([]);


    useEffect(() => {
        if (organisationOptions) {
            let shipperArr = [];
            let consigneeArr = [];

            organisationOptions.map(object => {
                if (object.entity && object.entity.includes("shipper")) {
                    shipperArr.push(object);
                }
                if (object.entity && object.entity.includes("consignee")) {
                    consigneeArr.push(object);
                }
            });
            setShipperOrganisationOptions(shipperArr);
            setConsigneeOrganisationOptions(consigneeArr);
        }
    }, [organisationOptions]);


    const handleShipperBranch = (shipper_id) => {
        if (shipper_id && token && user_id) {
            dispatch(getFFAirImpShipperBranch(token, user_id, shipper_id));
        }
    };
    const handleShipperBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirImpShipperBranchBank(token, user_id, branch_id));
        }
    };

    const handleConsigneeBranch = (consignee_id) => {
        if (consignee_id && token && user_id) {
            dispatch(getFFAirImpConsigneeBranch(token, user_id, consignee_id));
        }
    };
    const handleConsigneeBanks = (branch_id) => {
        if (branch_id && token && user_id) {
            dispatch(getFFAirImpConsigneeBranchBank(token, user_id, branch_id));
        }
    };


    const {
        //organisation shipper branch list
        loadingFFAirImpShipperBranchList,
        FFAirImpShipperBranchList,
        FFAirImpShipperBranchListError,

        //organisation consignee branch list
        loadingFFAirImpConsigneeBranchList,
        FFAirImpConsigneeBranchList,
        FFAirImpConsigneeBranchListError,

        //organisatoin shipper branch bank list
        loadingFFAirImpShipperBranchBankList,
        FFAirImpShipperBranchBankList,
        FFAirImpShipperBranchBankListError,

        //organisatoin consignee branch bank list
        loadingFFAirImpConsigneeBranchBankList,
        FFAirImpConsigneeBranchBankList,
        FFAirImpConsigneeBranchBankListError,
    } = useSelector(state => state.FFAirImpReducer);

    useEffect(() => {
        // console.log(FFAirImpShipperBranchList);
        if (FFAirImpShipperBranchList) {
            let arr = [];
            FFAirImpShipperBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setShipperBranchOptions(arr);
        }
    }, [FFAirImpShipperBranchList]);

    useEffect(() => {
        if (FFAirImpShipperBranchBankList) {
            let arr = [];
            FFAirImpShipperBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setShipperBankOptions(arr);
        }
    }, [FFAirImpShipperBranchBankList]);

    useEffect(() => {
        if (FFAirImpConsigneeBranchList) {
            let arr = [];
            FFAirImpConsigneeBranchList.map(val => arr.push({ value: val.id, label: val.branch_name }));
            setConsigneeBranchOptions(arr);
        }
    }, [FFAirImpConsigneeBranchList]);

    useEffect(() => {
        if (FFAirImpConsigneeBranchBankList) {
            let arr = [];
            FFAirImpConsigneeBranchBankList.map(val => arr.push({ value: val.id, label: val.entity_name }));
            setConsigneeBankOptions(arr);
        }
    }, [FFAirImpConsigneeBranchBankList]);




    const initialValues = {
        job_order_id: 0,
        quotation_id: 0,
        shipper_id: "",
        shipper_branch_id: "",
        shipper_branch_bank_account_id: "",
        consignee_id: "",
        consignee_branch_id: "",
        consignee_branch_bank_account_id: "",
        issuing_carrier_agent_id: "",
        issuing_carrier_agent_name: "",
        issuing_carrier_agent_address: "",
        agent_iata_code: "",
        agent_account_number: "",
        handling_info: "",
        nature_and_qty: "",
        remarks: "",
        airwaybill_date: "",
        clearance_Exec_date: "",
        CSR_date: "",
        executed_at: "",
        is_sli_recived: "",
        airport_of_departure_id: "",
        airport_of_departure_name: "",
        airport_of_destination_id: "",
        airport_of_destination_name: "",
        to_one: "",
        by_first_carrier: "",
        to_two: "",
        by_one: "",
        to_three: "",
        by_two: "",
        flight_no_one: "",
        flight_date_one: "",
        flight_no_two: "",
        flight_date_two: "",
        cto: "",
        currency: "",
        chgs_code: "",
        wt_val: "",
        other: "",
        declared_value_for_carriage: "",
        declared_value_for_customs: "",
        amount_of_insurance: "",

        weight_charge_prepaid: "0",
        weight_charge_collect: "0",
        valuation_charge_prepaid: "0",
        valuation_charge_collect: "0",
        tax_prepaid: "0",
        tax_collect: "0",
        total_due_agent_prepaid: "0",
        total_due_agent_collect: "0",
        total_due_carrier_prepaid: "0",
        total_due_carrier_collect: "0",
        total_prepaid: "0",
        total_collect: "0",

        rows: [
            {
                no_of_pkg: "",
                gross_wt: "",
                kg_lb: "",
                rate_class: "",
                comm_item_No: "",
                chargeable_wt: "",
                rate_charge: "",
                total_freight: "",
            }
        ],
        // ---------- NEW: flight_segments array ----------
        flight_segments: [],
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            // console.log(values);
            values.job_order_id = job_order_id;
            values.quotation_id = quotation_id;

            values.rate_description_json = values.rows;
            // ---------- include flight_segments ----------
            values.flight_segments = values.flight_segments;
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                let id = atob(b64id);
                if (id) {
                    values.id = id
                } else {
                    toast.error("Could not get MAWB Id.");
                    return;
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/air/import/direct-shipment/mawb/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            //reset all the dropdowns
                            setShipperOrganisationOptions([]);
                            setConsigneeOrganisationOptions([]);
                            setShipperBranchOptions([]);
                            setConsigneeBranchOptions([]);
                            setShipperBankOptions([]);
                            setConsigneeBankOptions([]);
                            navigate(`/flexichain/job-order/freight-forwarding/shipment/air/import/direct/mawb`)
                            // navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    // ---------- Add / Remove flight segments ----------
    const addFlightSegment = () => {
        const newSegment = { ...defaultSegment };
        const updatedSegments = [...formik.values.flight_segments, newSegment];
        setFlightSegments(updatedSegments);
        formik.setFieldValue("flight_segments", updatedSegments);
    };

    const removeFlightSegment = (index) => {
        if (formik.values.flight_segments.length <= 1) {
            toast.warning("At least one flight segment is required.");
            return;
        }
        const updatedSegments = formik.values.flight_segments.filter((_, i) => i !== index);
        setFlightSegments(updatedSegments);
        formik.setFieldValue("flight_segments", updatedSegments);
    };
    // ------------------------------------------------

    useEffect(() => {
        if (FFAirImpDirectMAWBDetail) {
            // console.log(FFAirImpDirectMAWBDetail);
            if (FFAirImpDirectMAWBDetail.shipper_id) { handleShipperBranch(FFAirImpDirectMAWBDetail.shipper_id) };
            if (FFAirImpDirectMAWBDetail.shipper_branch_id) { handleShipperBanks(FFAirImpDirectMAWBDetail.shipper_branch_id) };
            if (FFAirImpDirectMAWBDetail.consignee_id) { handleConsigneeBranch(FFAirImpDirectMAWBDetail.consignee_id) };
            if (FFAirImpDirectMAWBDetail.consignee_branch_id) { handleConsigneeBanks(FFAirImpDirectMAWBDetail.consignee_branch_id) };

            formik.setFieldValue("shipper_id", FFAirImpDirectMAWBDetail?.shipper_id);
            formik.setFieldValue("shipper_branch_id", FFAirImpDirectMAWBDetail?.shipper_branch_id);
            formik.setFieldValue("shipper_branch_bank_account_id", FFAirImpDirectMAWBDetail?.shipper_branch_bank_account_id);
            formik.setFieldValue("consignee_id", FFAirImpDirectMAWBDetail?.consignee_id);
            formik.setFieldValue("consignee_branch_id", FFAirImpDirectMAWBDetail?.consignee_branch_id);
            formik.setFieldValue("consignee_branch_bank_account_id", FFAirImpDirectMAWBDetail?.consignee_branch_bank_account_id);
            formik.setFieldValue("issuing_carrier_agent_id", FFAirImpDirectMAWBDetail?.issuing_carrier_agent_id ?? 0);
            formik.setFieldValue("issuing_carrier_agent_name", FFAirImpDirectMAWBDetail?.issuing_carrier_agent_name);
            formik.setFieldValue("issuing_carrier_agent_id", FFAirImpDirectMAWBDetail?.issuing_carrier_agent_id);
            formik.setFieldValue("issuing_carrier_agent_address", FFAirImpDirectMAWBDetail?.issuing_carrier_agent_address);
            formik.setFieldValue("agent_iata_code", FFAirImpDirectMAWBDetail?.agent_iata_code);
            formik.setFieldValue("agent_account_number", FFAirImpDirectMAWBDetail?.agent_account_number);
            formik.setFieldValue("handling_info", FFAirImpDirectMAWBDetail?.handling_info);
            formik.setFieldValue("nature_and_qty", FFAirImpDirectMAWBDetail?.nature_and_qty);
            formik.setFieldValue("remarks", FFAirImpDirectMAWBDetail?.remarks);
            formik.setFieldValue("airwaybill_date", FFAirImpDirectMAWBDetail?.airwaybill_date);
            formik.setFieldValue("clearance_Exec_date", FFAirImpDirectMAWBDetail?.clearance_Exec_date);
            formik.setFieldValue("CSR_date", FFAirImpDirectMAWBDetail?.CSR_date);
            formik.setFieldValue("executed_at", FFAirImpDirectMAWBDetail?.executed_at);
            formik.setFieldValue("is_sli_recived", FFAirImpDirectMAWBDetail?.is_sli_recived);

            // ---------- Populate single fields from first segment (for backward compatibility) ----------
            const firstSegment = FFAirImpDirectMAWBDetail?.ai_direct_shipment_booking_routing?.[0] || {};
            formik.setFieldValue("airport_of_departure_id", firstSegment?.airport_of_departure_id || "");
            formik.setFieldValue("airport_of_departure_name", firstSegment?.airport_of_departure_name || "");
            formik.setFieldValue("airport_of_destination_id", firstSegment?.airport_of_destination_id || "");
            formik.setFieldValue("airport_of_destination_name", firstSegment?.airport_of_destination_name || "");
            formik.setFieldValue("to_one", firstSegment?.to_one || "");
            formik.setFieldValue("by_first_carrier", firstSegment?.by_first_carrier || "");
            formik.setFieldValue("to_two", firstSegment?.to_two || "");
            formik.setFieldValue("by_one", firstSegment?.by_one || "");
            formik.setFieldValue("to_three", firstSegment?.to_three || "");
            formik.setFieldValue("by_two", firstSegment?.by_two || "");
            formik.setFieldValue("flight_no_one", firstSegment?.flight_no_one || "");
            formik.setFieldValue("flight_date_one", firstSegment?.flight_date_one || "");
            formik.setFieldValue("flight_no_two", firstSegment?.flight_no_two || "");
            formik.setFieldValue("flight_date_two", firstSegment?.flight_date_two || "");
            formik.setFieldValue("cto", firstSegment?.cto || "");


            formik.setFieldValue("currency", FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration ? Number(FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration.currency) : "");
            formik.setFieldValue("chgs_code", FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration.chgs_code : "");
            formik.setFieldValue("wt_val", FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration.wt_val : "");
            formik.setFieldValue("other", FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration.other : "");
            formik.setFieldValue("declared_value_for_carriage", FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration.declared_value_for_carriage : "");
            formik.setFieldValue("declared_value_for_customs", FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration.declared_value_for_customs : "");
            formik.setFieldValue("amount_of_insurance", FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_charge_declaration.amount_of_insurance : "");

            formik.setFieldValue("weight_charge_prepaid", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.weight_charge_prepaid : "");
            formik.setFieldValue("weight_charge_collect", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.weight_charge_collect : "");
            formik.setFieldValue("valuation_charge_prepaid", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.valuation_charge_prepaid : "");
            formik.setFieldValue("valuation_charge_collect", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.valuation_charge_collect : "");
            formik.setFieldValue("tax_prepaid", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.tax_prepaid : "");
            formik.setFieldValue("tax_collect", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.tax_collect : "");
            formik.setFieldValue("total_due_agent_prepaid", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.total_due_agent_prepaid : "");
            formik.setFieldValue("total_due_agent_collect", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.total_due_agent_collect : "");
            formik.setFieldValue("total_due_carrier_prepaid", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.total_due_carrier_prepaid : "");
            formik.setFieldValue("total_due_carrier_collect", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.total_due_carrier_collect : "");
            formik.setFieldValue("total_prepaid", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.total_prepaid : "");
            formik.setFieldValue("total_collect", FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration ? FFAirImpDirectMAWBDetail?.ai_direct_shipment_prepaid_collect_charge_declaration?.total_collect : "");

            if (FFAirImpDirectMAWBDetail?.ai_direct_shipment_rate_description && Array.isArray(FFAirImpDirectMAWBDetail?.ai_direct_shipment_rate_description)) {
                // console.log(FFAirImpDirectMAWBDetail.ai_direct_shipment_rate_description);
                const arr = FFAirImpDirectMAWBDetail.ai_direct_shipment_rate_description.map((item) => ({
                    no_of_pkg: item.no_of_pkg || "",
                    gross_wt: item.gross_wt || "",
                    kg_lb: item.kg_lb || "",
                    rate_class: item.rate_class || "",
                    comm_item_No: item.comm_item_No || "",
                    chargeable_wt: item.chargeable_wt || "",
                    rate_charge: item.rate_charge || "",
                    total_freight: item.total_freight || "",
                }));

                // console.log("Mapped Rows:", arr); // Check the mapped rows
                formik.setFieldValue("rows", arr);
            }

            // ---------- Populate flight_segments from API ----------
            const bookingRouting = FFAirImpDirectMAWBDetail?.ai_direct_shipment_booking_routing || [];
            if (bookingRouting.length > 0) {
                const segments = bookingRouting.map((item) => ({
                    id: item.id, // keep id for update if needed
                    airport_of_departure_id: item.airport_of_departure_id || "",
                    airport_of_departure_name: item.airport_of_departure_name || "",
                    airport_of_destination_id: item.airport_of_destination_id || "",
                    airport_of_destination_name: item.airport_of_destination_name || "",
                    to: item.to_one || "",
                    to_second: item.to_two || "",
                    by_first_carrier: item.by_first_carrier || "",
                    by_second_carrier: item.by_one || "",
                    flight_no: item.flight_no_one || "",
                    flight_date: item.flight_date_one || "",
                    cto: item.cto || "",
                }));
                setFlightSegments(segments);
                formik.setFieldValue("flight_segments", segments);
            } else {
                // If no segments, start with one empty
                const defaultSeg = [{ ...defaultSegment }];
                setFlightSegments(defaultSeg);
                formik.setFieldValue("flight_segments", defaultSeg);
            }
        }
    }, [FFAirImpDirectMAWBDetail]);

    useEffect(() => {
        // Perform calculations and update the rows without causing an infinite loop
        const calculateFreight = () => {
            // console.log("calculate freight is called")
            const updatedRows = formik.values.rows.map((row) => {
                const num1 = Number(row.chargeable_wt);
                const num2 = Number(row.rate_charge);

                return {
                    ...row,
                    total_freight: !isNaN(num1) && !isNaN(num2) ? num1 * num2 : "",
                };
            });
            console.log("updatedRows,",updatedRows);
            // Only update the rows if something changed to prevent unnecessary updates
            if (JSON.stringify(formik.values.rows) !== JSON.stringify(updatedRows)) {
                console.log("Changing row values");
                formik.setFieldValue("rows", updatedRows, false); // Set `shouldValidate` to `false` to avoid validation triggering on each update
            }
        };

        calculateFreight();
    }, [formik.values.rows.map(row => row.chargeable_wt), formik.values.rows.map(row => row.rate_charge)]);



    // useEffect(() => {
    //     if (formik.values.chargeable_wt1 && formik.values.rate_charge1) {
    //         let num1 = Number(formik.values.chargeable_wt1);
    //         let num2 = Number(formik.values.rate_charge1);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight1", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight1", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight1", "");
    //     }
    // }, [formik.values.chargeable_wt1, formik.values.rate_charge1]);

    // useEffect(() => {
    //     if (formik.values.chargeable_wt2 && formik.values.rate_charge2) {
    //         let num1 = Number(formik.values.chargeable_wt2);
    //         let num2 = Number(formik.values.rate_charge2);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight2", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight2", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight2", "");
    //     }
    // }, [formik.values.chargeable_wt2, formik.values.rate_charge2]);

    // useEffect(() => {
    //     if (formik.values.chargeable_wt3 && formik.values.rate_charge3) {
    //         let num1 = Number(formik.values.chargeable_wt3);
    //         let num2 = Number(formik.values.rate_charge3);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight3", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight3", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight3", "");
    //     }
    // }, [formik.values.chargeable_wt3, formik.values.rate_charge3])

    // useEffect(() => {
    //     if (formik.values.chargeable_wt4 && formik.values.rate_charge4) {
    //         let num1 = Number(formik.values.chargeable_wt4);
    //         let num2 = Number(formik.values.rate_charge4);

    //         if (!isNaN(num1) && !isNaN(num2)) {
    //             formik.setFieldValue("total_freight4", num1 * num2)
    //         } else {
    //             formik.setFieldValue("total_freight4", "");
    //         }
    //     } else {
    //         formik.setFieldValue("total_freight4", "");
    //     }
    // }, [formik.values.chargeable_wt4, formik.values.rate_charge4])

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_prepaid)) ? Number(formik.values.weight_charge_prepaid) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_prepaid)) ? Number(formik.values.valuation_charge_prepaid) : 0;
        let num3 = !isNaN(Number(formik.values.tax_prepaid)) ? Number(formik.values.tax_prepaid) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_prepaid)) ? Number(formik.values.total_due_agent_prepaid) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_prepaid)) ? Number(formik.values.total_due_carrier_prepaid) : 0;
        formik.setFieldValue("total_prepaid", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_prepaid,
        formik.values.valuation_charge_prepaid,
        formik.values.tax_prepaid,
        formik.values.total_due_agent_prepaid,
        formik.values.total_due_carrier_prepaid,
    ]);

    useEffect(() => {
        let num1 = !isNaN(Number(formik.values.weight_charge_collect)) ? Number(formik.values.weight_charge_collect) : 0;
        let num2 = !isNaN(Number(formik.values.valuation_charge_collect)) ? Number(formik.values.valuation_charge_collect) : 0;
        let num3 = !isNaN(Number(formik.values.tax_collect)) ? Number(formik.values.tax_collect) : 0;
        let num4 = !isNaN(Number(formik.values.total_due_agent_collect)) ? Number(formik.values.total_due_agent_collect) : 0;
        let num5 = !isNaN(Number(formik.values.total_due_carrier_collect)) ? Number(formik.values.total_due_carrier_collect) : 0;
        formik.setFieldValue("total_collect", num1 + num2 + num3 + num4 + num5);
    }, [
        formik.values.weight_charge_collect,
        formik.values.valuation_charge_collect,
        formik.values.tax_collect,
        formik.values.total_due_agent_collect,
        formik.values.total_due_carrier_collect,
    ]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);
    const [disableDownloadDOC, setDisableDownloadDOC] = useState(false);

    const downloadSLIPDF = () => {
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/import/hawb/sli-pdf-download`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }

    const downloadSLIDOC = () => {
        setDisableDownloadDOC(true);
        let config = {
            headers: { 'auth-token': token, user_id: user_id },
            responseType: 'blob' // Ensure the response is treated as a binary blob
        };

        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/import/hawb/sli-doc-download`, config)
                .then(response => {
                    if (response.status === 200) {
                        // Create a Blob object from the response data
                        const blob = new Blob([response.data], { type: 'application/msword' });
                        const url = window.URL.createObjectURL(blob);

                        // Create an anchor element and trigger the download
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'FlexichainSLI.doc'); // Set the filename
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // Clean up the DOM
                        setDisableDownloadDOC(false);
                    } else {
                        toast.error(response.error.message || "Error downloading the document");
                        setDisableDownloadDOC(false);
                    }
                })
                .catch(error => {
                    console.error(error);
                    toast.error(error.message || "Error during download");
                    setDisableDownloadDOC(false);
                });
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Unexpected error occurred");
            setDisableDownloadDOC(false);
        }
    };


    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <h3 className='mt-2'>Direct Shipment MAWB</h3>
                    <h4 className='mt-2'>Party Details</h4>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                SLI received
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className='form-control form-control-sm'
                                    name="is_sli_recived"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.is_sli_recived}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2 d-flex align-items-center justify-content-end">
                        {accessedPermission.includes("ff_ae_console_shipment_hawb_sli_download") && <div className="row d-flex justify-content-end">
                            <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" onClick={downloadSLIPDF} disabled={disableDownloadPDF}>{disableDownloadPDF ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (PDF)</>}</button></div>
                            {/* <div className="col-md-6"><button className="btn btn-sm btn-primary" type="button" style={{ whiteSpace: "nowrap" }} onClick={downloadSLIDOC} disabled={disableDownloadDOC}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</button></div> */}
                            <div className="col-md-6"><Link className="btn btn-sm btn-primary" type="button" style={{ whiteSpace: "nowrap" }} to={`${adminMainUrl}/FreightForwardingSLI/FF_AI_SLI.docx`}>{disableDownloadDOC ? <><i className="fas fa-spinner fa-spin"></i> Downloading...</> : <><i className="fa-solid fa-download"></i>  Download SLI (DOC)</>}</Link></div>
                        </div>}
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperOrganisationOptions}
                                    styles={customStyles}
                                    name="shipper_id"
                                    onChange={option => {
                                        formik.setFieldValue("shipper_branch_id", "");
                                        formik.setFieldValue("shipper_branch_bank_account_id", "");
                                        setShipperBranchOptions([]);
                                        setShipperBankOptions([]);
                                        formik.setFieldValue('shipper_id', option.value);
                                        handleShipperBranch(option.value);
                                    }}
                                    value={shipperOrganisationOptions.find(option => option.value === formik.values.shipper_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperBranchOptions}
                                    styles={customStyles}
                                    name="shipper_branch_id"
                                    onChange={option => {
                                        formik.setFieldValue("shipper_branch_bank_account_id", "");
                                        setShipperBankOptions([]);
                                        formik.setFieldValue('shipper_branch_id', option.value);
                                        handleShipperBanks(option.value);
                                    }}
                                    value={shipperBranchOptions.find(option => option.value === formik.values.shipper_branch_id || null)}
                                    isLoading={loadingFFAirImpShipperBranchList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Shipper Branch Account No.
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={shipperBankOptions}
                                    styles={customStyles}
                                    name="shipper_branch_bank_account_id"
                                    onChange={option => {
                                        formik.setFieldValue('shipper_branch_bank_account_id', option.value);
                                    }}
                                    value={shipperBankOptions.find(option => option.value === formik.values.shipper_branch_bank_account_id || null)}
                                    isLoading={loadingFFAirImpConsigneeBranchBankList}
                                // isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6"></div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeOrganisationOptions}
                                    styles={customStyles}
                                    name="quotation_id"
                                    onChange={option => {
                                        setConsigneeBranchOptions([]);
                                        setConsigneeBankOptions([]);
                                        formik.setFieldValue("consignee_branch_id", "");
                                        formik.setFieldValue("consignee_branch_bank_account_id", "");
                                        formik.setFieldValue('consignee_id', option.value);
                                        handleConsigneeBranch(option.value);
                                    }}
                                    value={consigneeOrganisationOptions.find(option => option.value === formik.values.consignee_id || null)}
                                    isLoading={loadingOrganisation}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee Branch
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeBranchOptions}
                                    styles={customStyles}
                                    name="consignee_branch_id"
                                    onChange={option => {
                                        setConsigneeBankOptions([]);
                                        formik.setFieldValue("consignee_branch_bank_account_id", "");
                                        formik.setFieldValue('consignee_branch_id', option.value);
                                        handleConsigneeBanks(option.value);
                                    }}
                                    value={consigneeBranchOptions.find(option => option.value === formik.values.consignee_branch_id || null)}
                                    isLoading={loadingFFAirImpShipperBranchList}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Consignee Branch Account No.
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={consigneeBankOptions}
                                    styles={customStyles}
                                    name="consignee_branch_bank_account_id"
                                    onChange={option => {
                                        formik.setFieldValue('consignee_branch_bank_account_id', option.value);
                                    }}
                                    value={consigneeBankOptions.find(option => option.value === formik.values.consignee_branch_bank_account_id || null)}
                                    isLoading={loadingFFAirImpConsigneeBranchBankList}
                                // isDisabled={false}  
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 mt-2">
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                IATA Agent
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <Select
                                    className='custom-selector'
                                    options={iataAgentOptions}
                                    styles={customStyles}
                                    name="issuing_carrier_agent_id"
                                    onChange={option => {
                                        formik.setFieldValue('issuing_carrier_agent_id', option.value);
                                    }}
                                    value={iataAgentOptions.find(option => option.value === formik.values.issuing_carrier_agent_id || null)}
                                // isLoading={loadingFFAirExpConsigneeBranchBankList}
                                // isDisabled={false}  
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-6"></div> */}

                    {/* Agent Name */}
                    {/* <InputTextJSX labelText={"Agent Name"} nameValue={"issuing_carrier_agent_name"} value={formik.values.issuing_carrier_agent_name} onChange={formik.handleChange} maxLength={100} />
                    <InputTextJSX labelText={"Agent Address"} nameValue={"issuing_carrier_agent_address"} value={formik.values.issuing_carrier_agent_address} onChange={formik.handleChange} />
                    <InputTextJSX labelText={"Agent IATA Code"} nameValue={"agent_iata_code"} value={formik.values.agent_iata_code} onChange={formik.handleChange} maxLength={10} />
                    <InputTextJSX labelText={"Agent Account No."} nameValue={"agent_account_number"} value={formik.values.agent_account_number} onChange={formik.handleChange} maxLength={30} /> */}

                    {/* ================== OLD FLIGHT SECTION – HIDDEN (kept for compatibility) ================== */}
                    <div style={{ display: 'none' }}>
                        <h4 className='mt-2'>Flight Booking/ Routing</h4>

                        <div className="col-md-6 mt-2">
                            <div className='ms-2'>
                                <label htmlFor="" className='form-label  mb-0'>
                                    Airport of Departure
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select
                                        className='custom-selector'
                                        options={airportOptions}
                                        styles={customStyles}
                                        name="airport_of_departure_id"
                                        onChange={(option) => {
                                            formik.setFieldValue("airport_of_departure_id", option.value)
                                            formik.setFieldValue("airport_of_departure_name", option.label)
                                        }}
                                        value={airportOptions.find(option => option.value === formik.values.airport_of_departure_id || null)}
                                        isLoading={loadingAirport}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className='ms-2'>
                                <label htmlFor="" className='form-label  mb-0'>
                                    Airport of Destination
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <Select
                                        className='custom-selector'
                                        options={airportOptions}
                                        styles={customStyles}
                                        name="airport_of_destination_id"
                                        onChange={(option) => {
                                            formik.setFieldValue("airport_of_destination_id", option.value)
                                            formik.setFieldValue("airport_of_destination_name", option.label)
                                        }}
                                        value={airportOptions.find(option => option.value === formik.values.airport_of_destination_id || null)}
                                        isLoading={loadingAirport}
                                    />
                                </div>
                            </div>
                        </div>


                        <InputTextJSX labelText={"To"} nameValue={"to_one"} value={formik.values.to_one} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                        <InputTextJSX labelText={"By First Carrier"} nameValue={"by_first_carrier"} value={formik.values.by_first_carrier} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                        <InputTextJSX labelText={"To"} nameValue={"to_two"} value={formik.values.to_two} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                        <InputTextJSX labelText={"By"} nameValue={"by_one"} value={formik.values.by_one} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                        <InputTextJSX labelText={"To"} nameValue={"to_three"} value={formik.values.to_three} onChange={formik.handleChange} splithalf={true} maxLength={30} />
                        <InputTextJSX labelText={"By"} nameValue={"by_two"} value={formik.values.by_two} onChange={formik.handleChange} splithalf={true} maxLength={30} />

                        <div className={`col-md-6 mt-2`}>
                            <div className='ms-2'>
                                <label htmlFor="" className='form-label  mb-0'>
                                    CTO
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <select
                                        className="form-control form-control-sm"
                                        id="cto"
                                        name="cto"
                                        value={formik.values.cto}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    >
                                        <option value="" disabled>-</option>
                                        <option value="DCSC">DCSC</option>
                                        <option value="CELEBI">CELEBI</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <InputTextJSX labelText={"Flt No 1"} nameValue={"flight_no_one"} value={formik.values.flight_no_one} onChange={formik.handleChange} maxLength={15} />
                        {/* <InputDateJSX labelText={"Flt Dt 1"} nameValue={"flight_date_one"} value={formik.values.flight_date_one} onChange={formik.handleChange} /> */}
                        <div className="col-md-6 mt-2">
                            <div className='ms-2'>
                                <label htmlFor="" className='form-label  mb-0'>
                                    Flt Dt 1
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        id={"flight_date_one"}
                                        name={"flight_date_one"}
                                        value={formik.values.flight_date_one}
                                        onChange={formik.handleChange}
                                        min={new Date().toISOString().split("T")[0]}
                                    />
                                </div>
                            </div>
                        </div>
                        <InputTextJSX labelText={"Flt No 2"} nameValue={"flight_no_two"} value={formik.values.flight_no_two} onChange={formik.handleChange} maxLength={15} />
                        {/* <InputDateJSX labelText={"Flt Dt 2"} nameValue={"flight_date_two"} value={formik.values.flight_date_two} onChange={formik.handleChange} /> */}
                        <div className="col-md-6 mt-2">
                            <div className='ms-2'>
                                <label htmlFor="" className='form-label  mb-0'>
                                    Flt Dt 2
                                </label>
                                <div className="icon-forms mb-3 mb-sm-0">
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        id={"flight_date_two"}
                                        name={"flight_date_two"}
                                        value={formik.values.flight_date_two}
                                        onChange={formik.handleChange}
                                        min={new Date().toISOString().split("T")[0]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ================== END OLD FLIGHT SECTION ================== */}

                    {/* ================== NEW DYNAMIC FLIGHT SEGMENTS ================== */}
                    <h4 className='mt-2'>Flight Booking / Routing</h4>

                    {formik.values.flight_segments && formik.values.flight_segments.map((segment, idx) => (
                        <div key={idx} className="mt-2 border p-2 position-relative">
                            {/* Remove button for each segment */}
                            <button
                                type="button"
                                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                onClick={() => removeFlightSegment(idx)}
                                disabled={formik.values.flight_segments.length <= 1}
                                title="Remove this flight segment"
                            >
                                −
                            </button>

                            {/* Row 1: Airports */}
                            <div className="row g-1">
                                <div className="col-md-6">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">Airport of Departure</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <Select
                                                className="custom-selector"
                                                options={airportOptions}
                                                styles={customStyles}
                                                name={`flight_segments.${idx}.airport_of_departure_id`}
                                                onChange={(option) => {
                                                    formik.setFieldValue(`flight_segments.${idx}.airport_of_departure_id`, option.value);
                                                    formik.setFieldValue(`flight_segments.${idx}.airport_of_departure_name`, option.label);
                                                }}
                                                value={airportOptions.find(option => option.value === segment.airport_of_departure_id) || null}
                                                isLoading={loadingAirport}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">Airport of Destination</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <Select
                                                className="custom-selector"
                                                options={airportOptions}
                                                styles={customStyles}
                                                name={`flight_segments.${idx}.airport_of_destination_id`}
                                                onChange={(option) => {
                                                    formik.setFieldValue(`flight_segments.${idx}.airport_of_destination_id`, option.value);
                                                    formik.setFieldValue(`flight_segments.${idx}.airport_of_destination_name`, option.label);
                                                }}
                                                value={airportOptions.find(option => option.value === segment.airport_of_destination_id) || null}
                                                isLoading={loadingAirport}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Row 2: To, By First Carrier, To, By – 4 columns */}
                            <div className="row g-2 mt-2">
                                <div className="col-md-3">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">To</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`flight_segments.${idx}.to`}
                                                value={segment.to || ""}
                                                onChange={formik.handleChange}
                                                maxLength={100}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">By First Carrier</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`flight_segments.${idx}.by_first_carrier`}
                                                value={segment.by_first_carrier || ""}
                                                onChange={formik.handleChange}
                                                maxLength={100}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">To</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`flight_segments.${idx}.to_second`}
                                                value={segment.to_second || ""}
                                                onChange={formik.handleChange}
                                                maxLength={100}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">By</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`flight_segments.${idx}.by_second_carrier`}
                                                value={segment.by_second_carrier || ""}
                                                onChange={formik.handleChange}
                                                maxLength={100}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Row 3: Flight Number, Flight Date, CTO */}
                            <div className="row g-2 mt-2">
                                <div className="col-md-4">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">Flight Number</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`flight_segments.${idx}.flight_no`}
                                                value={segment.flight_no || ""}
                                                onChange={formik.handleChange}
                                                maxLength={15}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">Flight Date</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                name={`flight_segments.${idx}.flight_date`}
                                                value={segment.flight_date || ""}
                                                onChange={formik.handleChange}
                                                min={new Date().toISOString().split("T")[0]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="ms-2">
                                        <label className="form-label mb-0">CTO</label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <select
                                                className="form-control form-control-sm"
                                                name={`flight_segments.${idx}.cto`}
                                                value={segment.cto || ""}
                                                onChange={formik.handleChange}
                                            >
                                                <option value="" disabled>-Select an option-</option>
                                                <option value="DCSC">DCSC</option>
                                                <option value="CELEBI">CELEBI</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* Add Flight button – positioned to the right */}
                    <div className="mt-2 d-flex justify-content-end">
                        <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={addFlightSegment}
                        >
                            + Add Flight
                        </button>
                    </div>

                    <h4 className='mt-2'>Charge Declaration</h4>
                    <SelectReactJSX
                        labelText={"Currency"}
                        nameValue={"currency"}
                        onChange={(option) => { formik.setFieldValue("currency", option.value) }}
                        options={currencyOptions}
                        value={currencyOptions.find(option => option.value === formik.values.currency || null)}
                        isLoading={loadingCurrency}
                    />

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                CHGS CODE
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className="form-control form-control-sm"
                                    id="chgs_code"
                                    name="chgs_code"
                                    value={formik.values.chgs_code}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="PP">PP</option>
                                    <option value="PC">PC</option>
                                    <option value="CP">CP</option>
                                    <option value="CC">CC</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Wt/Val(P/C)
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className="form-control form-control-sm"
                                    id="wt_val"
                                    name="wt_val"
                                    value={formik.values.wt_val}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="P">P</option>
                                    <option value="C">C</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className={`col-md-6 mt-2`}>
                        <div className='ms-2'>
                            <label htmlFor="" className='form-label  mb-0'>
                                Other(P/C)
                            </label>
                            <div className="icon-forms mb-3 mb-sm-0">
                                <select
                                    className="form-control form-control-sm"
                                    id="other"
                                    name="other"
                                    value={formik.values.other}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                >
                                    <option value="" disabled>-</option>
                                    <option value="P">P</option>
                                    <option value="C">C</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <InputTextJSX labelText={"Declared Value for Carriage"} nameValue={"declared_value_for_carriage"} value={formik.values.declared_value_for_carriage} onChange={formik.handleChange} />
                    <InputTextJSX labelText={"Declared Value for Customs"} nameValue={"declared_value_for_customs"} value={formik.values.declared_value_for_customs} onChange={formik.handleChange} />
                    <InputTextJSX labelText={"Amount of Insurance"} nameValue={"amount_of_insurance"} value={formik.values.amount_of_insurance} onChange={formik.handleChange} />
                    <TextAreaJSX labelText="Handeling Info" nameValue="handling_info" value={formik.values.handling_info} onChange={formik.handleChange} maxLength={430} showWordCount={true}/>

                    <h4 className='mt-2'>Rate Description</h4>
                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">No.of Pkg*</th>
                                    <th scope="col">Gross Wt.*</th>
                                    <th scope="col">Kg/ Lb /Ton</th>
                                    <th scope="col">Rate Class</th>
                                    <th scope="col">Comm. Item No</th>
                                    <th scope="col">Chargeable Wt.*</th>
                                    <th scope="col">Rate/ Charge*</th>
                                    <th scope="col">Total Freight</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formik.values.rows.map((row, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].no_of_pkg`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.no_of_pkg}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9]/g, '');
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].gross_wt`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.gross_wt}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].kg_lb`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.kg_lb}
                                            >
                                                <option value="" disabled>-</option>
                                                <option value="Kgs">Kgs</option>
                                                <option value="Lbs">Lbs</option>
                                                <option value="Ton">Ton</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].rate_class`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.rate_class}
                                            >
                                                <option value="">-</option>
                                                {
                                                    rateclassOptions.map((v, i) => {
                                                        return <option value={v.value} key={i + 1}>{v.label}</option>
                                                    })
                                                }
                                                {/* <option value="Q">Q</option>
                                                <option value="B">B</option>
                                                <option value="R">R</option>
                                                <option value="S">S</option>
                                                <option value="M">M</option>
                                                <option value="N">N</option>
                                                <option value="K">K</option>
                                                <option value="C">C</option>
                                                <option value="X">X</option>
                                                <option value="E">E</option>
                                                <option value="U">U</option>
                                                <option value="Y">Y</option> */}
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].comm_item_No`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.comm_item_No}
                                                maxLength={30}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].chargeable_wt`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.chargeable_wt}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].rate_charge`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.rate_charge}
                                                onInput={(event) => {
                                                    let value = event.target.value;

                                                    value = value.replace(/[^0-9.]/g, '');

                                                    const parts = value.split('.');

                                                    if (parts.length > 2) {
                                                        value = parts[0] + '.' + parts[1];
                                                    }

                                                    if (parts[1] && parts[1].length > 2) {
                                                        value = parts[0] + '.' + parts[1].substring(0, 2);
                                                    }

                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name={`rows[${index}].total_freight`}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={row.total_freight}
                                                disabled
                                            />
                                        </td>
                                        <td>
                                            {formik.values.rows.length > 1 && (
                                                <button
                                                    type="button"
                                                    title='Remove rates'
                                                    className="btn btn-sm btn-danger me-1"
                                                    onClick={() => {
                                                        const newRows = formik.values.rows.filter(
                                                            (_, i) => i !== index
                                                        );
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    -
                                                </button>
                                            )}
                                            {index === formik.values.rows.length - 1 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary ms-1"
                                                    onClick={() => {
                                                        const newRows = [...formik.values.rows];
                                                        newRows.push({
                                                            no_of_pkg: "",
                                                            gross_wt: "",
                                                            kg_lb: "",
                                                            rate_class: "",
                                                            comm_item_No: "",
                                                            chargeable_wt: "",
                                                            rate_charge: "",
                                                            total_freight: "",
                                                        });
                                                        formik.setFieldValue("rows", newRows);
                                                    }}
                                                >
                                                    +
                                                </button>
                                            )}

                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    </div>

                    <TextAreaJSX labelText="Nature and Quantity" nameValue="nature_and_qty" value={formik.values.nature_and_qty} onChange={formik.handleChange} maxLength={400} showWordCount={true}/>
                    <TextAreaJSX labelText="Remarks" nameValue="remarks" value={formik.values.remarks} onChange={formik.handleChange} maxLength={380} showWordCount={true}/>

                    <h4 className='mt-2'>Prepaid / Collect Charge Declaration</h4>

                    <div className="table-responsive">
                        <table className="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Prepaid</th>
                                    <th scope="col">Collect</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Weight Charge */}
                                <tr>
                                    <td>
                                        Weight Charge
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="weight_charge_prepaid"
                                            id="weight_charge_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.weight_charge_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="weight_charge_collect"
                                            id="weight_charge_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.weight_charge_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Valuation Charge */}
                                <tr>
                                    <td>
                                        Valuation Charge
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="valuation_charge_prepaid"
                                            id="valuation_charge_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.valuation_charge_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="valuation_charge_collect"
                                            id="valuation_charge_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.valuation_charge_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Tax */}
                                <tr>
                                    <td>
                                        Tax
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="tax_prepaid"
                                            id="tax_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.tax_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="tax_collect"
                                            id="tax_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.tax_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Total Due Agent */}
                                <tr>
                                    <td>
                                        Total Due Agent
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_due_agent_prepaid"
                                            id="total_due_agent_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_due_agent_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_due_agent_collect"
                                            id="total_due_agent_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_due_agent_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Total Due Carrier */}
                                <tr>
                                    <td>
                                        Total Due Carrier
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_due_carrier_prepaid"
                                            id="total_due_carrier_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_due_carrier_prepaid}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_due_carrier_collect"
                                            id="total_due_carrier_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_due_carrier_collect}
                                            maxLength={10}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}

                                        />
                                    </td>
                                </tr>
                                {/* Total  */}
                                <tr>
                                    <td>
                                        Total
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_prepaid"
                                            id="total_prepaid"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_prepaid}
                                            maxLength={100}
                                            disabled
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            className='form-control form-control-sm'
                                            name="total_collect"
                                            id="total_collect"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.total_collect}
                                            maxLength={100}
                                            disabled
                                        />
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <InputDateJSX labelText="Airway Bill Date" nameValue="airwaybill_date" value={formik.values.airwaybill_date} onChange={formik.handleChange} minToday={true} />
                    <InputDateJSX labelText="CSR Date" nameValue="clearance_Exec_date" value={formik.values.clearance_Exec_date} onChange={formik.handleChange} minToday={true} />
                    <InputDateJSX labelText="Clearance/Exec.Dt" nameValue="CSR_date" value={formik.values.CSR_date} onChange={formik.handleChange} minToday={true} />
                    <InputDateJSX labelText="Executed At" nameValue="executed_at" value={formik.values.executed_at} onChange={formik.handleChange} minToday={true} />

                </div>
                <div className="row d-flex justify-content-end mt-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                        </button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default DirectShipmentMAWBEditAI